import React from 'react'
import { Link } from 'react-router-dom'

import MetadataLabel from './MetadataLabel'
import * as dateLib from '../../../libraries/date'
import ContentTag from './ContentTag'
import AuthorsLabel from './AuthorsLabel'
import ClickableCard from '../layout/ClickableCard'
import PlayCircle from '../../../assets/icons/play-circle.svg?react'
import ProgressBar from './VideoProgressBar'
import BookmarkButton from './BookmarkButton'
import VideoCardPreviewMedia from './VideoCardPreviewMedia'

type Props = {
  id: number,
  title: string,
  image?: string,
  previewUrl?: string,
  authors: Array<string>,
  duration: number,
  viewersCount?: number,
  type: { name: string, color: string },
  difficulty: string,
  category: string,
  watched?: boolean,
  currentPlayTime?: number,
  bookmarked?: boolean
}
const MobileVerticalVideoCard: React.FC<Props> = ({ id, title, image, previewUrl, authors, duration, type, difficulty, category, watched, currentPlayTime, bookmarked, viewersCount }) => {
  const [cardHovered, setCardHovered] = React.useState(false)

  return (
    <ClickableCard>
      <div className='h-full'>
        <Link
          to={`/content/videos/${id}`}
          className='block relative'
          onMouseEnter={() => setCardHovered(true)}
          onMouseLeave={() => setCardHovered(false)}
        >
            <div className='relative'>
              <div className='pointer-events-none z-10 rounded-t-lg absolute w-full h-28 sm:h-48 flex flex-col items-center justify-top p-2 top-0 text-center text-white font-light'>
                <div className='text-sm border-b border-b-white border-solid pb-0 mb-1'>{type.name}</div>
                <div className='text-xs '>{difficulty}</div>
              </div>
              <div className='relative'>
                <div className='pointer-events-none absolute bottom-2 end-3'><PlayCircle className='fill-white w-9 h-9' /></div>
                <VideoCardPreviewMedia
                  alt={title}
                  posterSrc={image}
                  previewSrcUrl={previewUrl}
                  cardHovered={cardHovered}
                  className='w-full rounded-t-lg object-cover'
                />
                <ProgressBar duration={duration} watched={watched} currentPlayTime={currentPlayTime} />
              </div>
            </div>
            <div className='p-2 w-full block'>
              <p className='h-10 line-clamp-2 text-black text-xs font-semibold'>{title}</p>
              <div className='flex flex-col text-gray-600 text-2xs mt-2'>
                <div className='h-12'><AuthorsLabel authors={authors} /></div>
                <div className='inline-flex items-center justify-between h-7'>
                  <MetadataLabel icon='clock'>{dateLib.parseSecondsToHoursAndMinutes(duration)}</MetadataLabel>
                  <MetadataLabel icon='play'>{viewersCount}</MetadataLabel>
                  {bookmarked && <BookmarkButton bookmarked onClick={() => {}} />}
                </div>
                <div className='text-2xs sm:text-xs inline-flex mt-2'>
                  <ContentTag label={category} bgColor='soft-green' textColor='deep-green' />
                </div>
              </div>
            </div>
        </Link>
      </div>
    </ClickableCard>
  )
}

export default MobileVerticalVideoCard
